import { activityItem } from '@lib/fragments/overview-fragment';
import gql from 'graphql-tag';

interface Props {
  filterCategories?: boolean;
  filterTags?: boolean;
  filterLocations?: boolean;
  filterTitle?: boolean;
}

const ACTIVITY_PAGES_QUERY = ({
  filterCategories,
  filterTags,
  filterLocations,
  filterTitle,
}: Props) => gql`
  query ACTIVITY_PAGES_QUERY(
    ${filterTitle ? '$title: String' : ''}
    ${filterCategories ? '$categories: [String!]' : ''}
    ${filterTags ? '$tags: [String!]' : ''}
    ${filterLocations ? '$locations: [String]' : ''}
    $limit: Int
    $skip: Int
    $locale: String
    $idNany: [String]
  ) {
    ActivityPages(
      limit: $limit
      skip: $skip
      locale: $locale
      where: {
        _id_nany: $idNany
        ${filterLocations ? 'location: { _slug_any: $locations }' : ''}
        ${filterCategories ? 'category: { _slug_any: $categories }' : ''}
        ${filterTags ? 'content_tags: { _slug_any: $tags }' : ''}
        _or: [
          ${
            filterTitle
              ? `
            { title_contains: $title }
            { content_tags: { title_contains: $title } }
          `
              : ''
          }
        ]
      }
    ) {
      items {
        ...activityItem
      }
      total
    }
  }
  ${activityItem}
`;

export default ACTIVITY_PAGES_QUERY;
